import { useNavigate } from 'react-router-dom'
import TableFilter from './tableFilter'
import ExportButton from '../../common/ExportButton'
import { appAllGetEventBooking } from '../../store/eventbooking'
import { eventBookingExportColumns } from '../../config/exportColumns/eventBookingExportColumns'
import { useDispatch } from 'react-redux'

function EventBooking() {
	const dispatch = useDispatch()
	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Event Booking</div>
					<div>
						<ExportButton
							fetchAction={params => dispatch(appAllGetEventBooking({ ...params, loading: false }))}
							filters={{}}
							columns={eventBookingExportColumns}
							fileName="Event Bookings"
							sheetName="Event Booking List"
							buttonText="Export Event Bookings"
						/>
					</div>
				</div>
				<TableFilter />
			</div>
		</>
	)
}

export default EventBooking
